/* ==========================================================================
   Edge Accessories — theme behaviour
   Ported from the static site. Cart logic lives in cart.js.
   Everything here is progressive enhancement: the page is fully usable
   before this file runs.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------------------------------------------------- scroll reveal */
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    var items = document.querySelectorAll('.reveal');
    if (!items.length) return;

    // Only hide content once we know the observer will reveal it again.
    document.documentElement.classList.add('js-reveal');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });

    items.forEach(function (el) { observer.observe(el); });
  }

  /* -------------------------------------------------- product gallery */
  function initGallery() {
    var main = document.getElementById('galleryMain');
    var thumbs = document.querySelectorAll('.thumb-btn');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (button) {
      button.addEventListener('click', function () {
        main.src = button.dataset.full;
        main.alt = button.dataset.alt || '';
        thumbs.forEach(function (b) {
          b.setAttribute('aria-current', String(b === button));
        });
      });
    });
  }

  /* ------------------------------------------------- reading progress */
  function initReadingProgress() {
    var rail = document.getElementById('progressRail');
    var fill = document.getElementById('progressFill');
    var article = document.querySelector('.article-body');
    if (!rail || !fill || !article) return;

    rail.hidden = false;

    function update() {
      var box = article.getBoundingClientRect();
      var total = box.height - window.innerHeight;
      var read = total > 0 ? -box.top / total : (box.top <= 0 ? 1 : 0);
      fill.style.width = Math.min(100, Math.max(0, read * 100)) + '%';
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  /* ---------------------------------------------- article contents nav */
  // Build the list from the headings the writer actually used, so an
  // article authored in Shopify's editor gets a contents list without
  // anyone maintaining one. Articles with fewer than two headings don't
  // need one, so the whole nav is removed.
  function buildTableOfContents() {
    var toc = document.getElementById('toc');
    var body = document.querySelector('.article-body');
    if (!toc || !body) return;

    var list = toc.querySelector('ol');
    var headings = body.querySelectorAll('h2');

    if (!list || headings.length < 2) {
      toc.remove();
      return;
    }

    headings.forEach(function (heading, index) {
      if (!heading.id) {
        // Slug from the text, with the index as a tiebreaker for duplicates.
        var slug = heading.textContent
          .toLowerCase()
          .replace(/[^\w\s-]/g, '')
          .trim()
          .replace(/\s+/g, '-')
          .slice(0, 48);
        heading.id = (slug || 'section') + '-' + (index + 1);
      }

      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent;
      item.appendChild(link);
      list.appendChild(item);
    });

    toc.hidden = false;
  }

  function initTableOfContents() {
    var links = document.querySelectorAll('#toc a');
    if (!links.length || !('IntersectionObserver' in window)) return;

    var map = {};
    links.forEach(function (link) {
      var id = link.getAttribute('href');
      if (!id || id.charAt(0) !== '#') return;
      var target = document.querySelector(id);
      if (target) map[target.id] = link;
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        links.forEach(function (l) { l.classList.remove('is-active'); });
        if (map[entry.target.id]) map[entry.target.id].classList.add('is-active');
      });
    }, { rootMargin: '0px 0px -70% 0px', threshold: 0 });

    Object.keys(map).forEach(function (id) {
      observer.observe(document.getElementById(id));
    });
  }

  /* ---------------------------------------------------- form validation */
  // Shopify posts these forms server-side; this only surfaces the browser's
  // own validity state using the theme's styling rather than default bubbles.
  function initFormValidation() {
    document.querySelectorAll('form[novalidate]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        if (form.checkValidity()) return;
        event.preventDefault();
        form.classList.add('was-validated');
        var firstInvalid = form.querySelector(':invalid');
        if (firstInvalid) firstInvalid.focus();
      });
    });
  }

  /* ------------------------------------------------------- copy link */
  function initCopyLink() {
    var button = document.getElementById('copyLink');
    var status = document.getElementById('copyStatus');
    if (!button) return;

    // Without the clipboard API there is nothing useful the button can do.
    if (!navigator.clipboard) {
      button.closest('li').remove();
      return;
    }

    button.addEventListener('click', function () {
      navigator.clipboard.writeText(window.location.href).then(function () {
        if (status) status.textContent = 'Link copied to clipboard.';
        button.setAttribute('aria-label', 'Link copied');
        setTimeout(function () {
          if (status) status.textContent = '';
          button.setAttribute('aria-label', 'Copy link to this article');
        }, 2500);
      });
    });
  }

  function init() {
    initReveal();
    initGallery();
    initReadingProgress();
    buildTableOfContents();
    initTableOfContents();
    initCopyLink();
    initFormValidation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
